import Vue from "vue";
import Vuex from "vuex";
import loginService from "../services/loginService";
import menuService from "../services/menuService";
import router from "../router";

Vue.use(Vuex);

import usersModule from "./Users";
import rolesModule from "./Roles";
import profilesModule from "./Profiles";
import parametersModule from "./MinosParameters";
import userFormAdminModule from "./UserFormAdmin";
import profileUserModule from "./ProfileUser";
import userAccessLimits from "./UserAcessLimits";
import printConditionsModule from "./PrintConditions";
import dashboardModule from "./Dashboard";
import personsModule from "./Persons";
import securityParamsModule from "./SecurityParams";
import formatTypesModule from "./FormatTypes";
import queuesModule from "./Queues";
import formatsModule from "./Formats";
import documentsModule from "./Documents";
import packagesModule from "./Packages";
import integrationsModule from "./Integrations";
import dataMapsModule from "./DataMaps";
import ValueTypesVuexModule from "./ValueTypes";
import auditModule from "./Audit";
import axios from "axios";

export default new Vuex.Store({
  state() {
    return {
      /* Estado Global de la Aplicación*/
      appState: {
        isMobile: false,
        isDrawerOpen: false,
        isNotificationOpen: false,
        applicationId: 0,
        defaultDomain: "",
        menuData: {}
      },
      /*Estado Global del Usuario*/
      userState: {
        isLoggedIn: false,
        bearerToken: "",
        userData: {},
        userProfile: {},
        permissions: {}
      },
      /* Estado de los componentes de navegación */
      navState: {
        isUserMenu: false
      },
      drawerState: {
        drawerLogo: "", //base64InlineData?
        drawerTitle: "Título del Drawer",
        drawerItems: [] //Items a cargar dinámicamente del menú
      },

      apiParam: {
        axiosConfig: undefined,
        baseUrl: ""
      },
      authParam: {
        axiosConfig: undefined,
        baseUrl: ""
      },
      $_defaultHeaders: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
        "Cache-Control": "no-cache",
        "Access-Control-Allow-Origin": "*"
      },
      $_errorState: {},
      $_tokenExpired: false,
      $_paramLoaded: false
    };
  },
  getters: {
    drawerVisible: (state) => state.appState.isDrawerOpen,
    baseUrl: (state) => state.apiParam.baseUrl,
    axiosConfig: (state) => state.apiParam.axiosConfig,
    authaxiosConfig: (state) => state.authParam.axiosConfig,
    authUrl: (state) => state.authParam.baseUrl,
    apiUrl: (state) => state.apiParam.baseUrl,
    userData: (state) => state.userState.userData,
    userToken: (state) => state.userState.bearerToken,
    userPermissions: (state) => state.userState.permissions,
    loggedIn: (state) => state.userState.isLoggedIn,
    defaultHeaders: (state) => state.$_defaultHeaders,
    applicationId: (state) => state.appState.applicationId,
    domainName: (state) => state.appState.defaultDomain,
    menuData: (state) => state.appState.menuData,
    tokenExpired: (state) => state.$_tokenExpired,
    paramLoaded: (state) => state.$_paramLoaded
  },

  mutations: {
    toggleDrawerVisibility(state, value) {
      if (value == "open") state.appState.isDrawerOpen = true;
      if (value == "close") state.appState.isDrawerOpen = false;
    },
    SET_API_AXIOS(state, value) {
      state.apiParam.axiosConfig = value;
    },
    SET_AUTH_AXIOS(state, value) {
      state.authParam.axiosConfig = value;
    },
    SET_API_URL(state, value) {
      state.apiParam.baseUrl = value;
    },
    SET_AUTH_URL(state, value) {
      state.authParam.baseUrl = value;
    },
    LOGIN_USER(state, value) {
      //actualizar el estado del usuario
      state.userState.bearerToken = value;
      state.userState.isLoggedIn = true;
    },
    LOGOUT_USER(state, value) {
      state.userState = value;
      state.userState.bearerToken = "";
      state.userState.userData = {};
      state.userState.userProfile = {};
      state.userState.permissions = {};
      loginService.destroyUserData();
      //Acá es la mejor opción para limpiar el Timeout del Store de Vue Para el mensaje del cierre de sesión.
      // validar en https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/clearTimeout
    },
    SET_USER_DATA(state, value) {
      state.userState.userData = value;
    },
    SET_USER_PROFILE(state, value) {
      state.userState.userProfile = value;
      localStorage.setItem("profile", value);
    },
    SET_USER_PERMISSION(state, value) {
      state.userState.permissions = value;
    },
    SET_MENU_DATA(state, value) {
      state.appState.menuData = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    },
    SET_EXPIRED(state, value) {
      //Vue.set(state, "$_tokenExpired", value);
      state.$_tokenExpired = value;
    },
    SET_PARAM_LOADED(state, value) {
      //Vue.set(state, "$_tokenExpired", value);
      state.$_paramLoaded = value;
    }
  },
  actions: {
    setApiAxiosConfig({ commit }, value) {
      commit("SET_API_AXIOS", value);
    },
    setApiBaseUrl({ commit }, config) {
      config = config.endsWith("/") ? config : config + "/";
      commit("SET_API_URL", config);
    },
    setAuthAxiosConfig({ commit }, value) {
      commit("SET_AUTH_AXIOS", value);
    },
    setAuthBaseUrl({ commit }, config) {
      config = config.endsWith("/") ? config : config + "/";
      commit("SET_AUTH_URL", config);
    },
    setDefaultHeaders({ state }, value) {
      state.defaultHeaders = value;
    },
    /*
    setApplicationId({ state }, value) {
      state.appState.applicationId = value;
    },
    */
    setApplicationConfig({ state }, value) {
      state.appState.applicationId = value.ApplicationId;
      state.appState.defaultDomain = value.DefaultDomain;
    },
    async logInActionHandler({ commit, dispatch, getters }, payload) {
      //payload.isDomain, payload.Data
      let url = "";
      let isValid = false;

      let $_headers = getters.defaultHeaders;
      var axiosConf = {
        headers: $_headers
      };
      await dispatch("setAuthAxiosConfig", axiosConf);

      if (!payload.isDomain) {
        url = getters.authUrl + "Account/v1.0/LoginApplicationAsync";
      } else {
        url = getters.authUrl + "Account/v1.0/LoginADAsync";
      }

      //let response = await axios.post(url, payload.data);
      try {
        let response = await axios.post(url, payload.data, axiosConf);
        var salida = response.data;

        if (salida.data && salida.success) {
          //Loguear el usuario Axios + Aplicación.
          commit("LOGIN_USER", salida.data.token);
          if (loginService.parseClaims(salida.data.token)) {
            commit("SET_USER_DATA", loginService.userData);
            loginService.persistUserData();
            /* Configurar los headers de Axios*/

            let $_headers = getters.defaultHeaders;
            $_headers["Authorization"] = "Bearer " + loginService.userToken;
            var config = {
              headers: $_headers
            };

            commit("SET_AUTH_AXIOS", config);
            commit("SET_API_AXIOS", config);

            /* Obtener los permisos del usuario */
            await dispatch("getUserProfile");
            await dispatch("validateUserState");
            //console.log(loginService.userData.FirstStart);

            //Acá es la mejor opción para setear el Timeout en un Store de Vue Para el mensaje del cierre de sesión.
            // validar en https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/clearTimeout

            var data = loginService.userData;

            if (!payload.isDomain) {
              if (data.FirstStart == "True" || data.ExpiredPassword == "True") {
                router.push("ChangePassword");
                isValid = false;
              } else {
                isValid = true;
                //router.push("/");
              }
            } else {
              isValid = true;
              //router.push("/");
            }

            return isValid;
          }
        } else {
          throw "Usuario y/o Contraseña incorrectos.";
        }
      } catch (error) {
        console.log(error);
        throw "Usuario y/o Contraseña incorrectos";
      }
    },
    async getUserProfile({ commit, state, rootGetters }) {
      var baseUrl = rootGetters.authUrl;

      var appId = state.appState.applicationId;
      var pId = state.userState.userData.ProfileId ?? "0";
      var profileId = parseInt(pId);
      try {
        if (profileId == 0)
          throw "El usuario no tiene perfil habilitado en Papirus!";
        /*
        var actionLink =
          baseUrl +
          "Profile/v1.0/GetProfilesByApplicationProfileAsync:" +
          profileId +
          "," +
          appId;
        */
        var actionLink =
          baseUrl +
          "Profile/v1.0/GetCurrentUserProfile:" +
          profileId +
          "," +
          appId;

        var axiosConfig = rootGetters.axiosConfig;

        const response = await axios.get(actionLink, axiosConfig);

        var finalProfile = loginService.mapUserProfile(
          response.data.data,
          state.userState.bearerToken
        );

        commit("SET_USER_PROFILE", finalProfile);
      } catch (error) {
        console.log(error);
        //router.push("/logout");
        throw error;
      }
    },
    async getUserPermissions({ state }) {
      return new Promise((resolve) => {
        var perm = state.userState.permissions;
        resolve(perm);
      });
    },
    async validateUserState({ commit, dispatch, getters }) {
      var loData = {
        isLoggedIn: false,
        bearerToken: "",
        userData: {}
      };

      try {
        if (loginService.retrieveUserData()) {
          if (Date.now() >= loginService.userData.exp * 1000) {
            commit("LOGOUT_USER", loData);
          }

          var tkn = localStorage["tkn"];
          commit("LOGIN_USER", tkn);

          //await dispatch("getUserProfile");
          var userProfile = localStorage["profile"];
          var menuData = menuService.getMenuObjectFromString(userProfile, tkn);
          var menuAccess = menuService.getMenuAccessFromString(
            userProfile,
            tkn
          );
          commit("SET_MENU_DATA", menuData);
          commit("SET_USER_PERMISSION", menuAccess);

          await dispatch("loadParameters");
        }
      } catch (error) {
        commit("LOGOUT_USER", loData);
      }

      return getters.loggedIn;
    },
    async loadPersistedState({ commit, dispatch, getters }) {
      var loData = {
        isLoggedIn: false,
        bearerToken: "",
        userData: {}
      };

      try {
        let $_headers = getters.defaultHeaders;
        let config = {};
        if (loginService.retrieveUserData()) {
          /* Encontró el estado actual del usuario */
          //validar si aun se tiene tiempo disponible
          if (Date.now() >= loginService.userData.exp * 1000) {
            commit("LOGOUT_USER", loData);
            //Validar si debe redirigrse al login
            //router.push("login");
          } else {
            commit("LOGIN_USER", loginService.userToken);
            commit("SET_USER_DATA", loginService.userData);

            /* Configurar los headers de Axios*/

            $_headers["Authorization"] = "Bearer " + loginService.userToken;
            config = {
              headers: $_headers
            };

            commit("SET_AUTH_AXIOS", config);
            commit("SET_API_AXIOS", config);

            await dispatch("validateUserState");

            //Acá es la mejor opción para setear el Timeout en un Store de Vue Para el mensaje del cierre de sesión.
            // validar en https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/clearTimeout
            //router.push("/");
          }
        } else {
          commit("LOGOUT_USER", loData);
          config = {
            headers: $_headers
          };
          commit("SET_AUTH_AXIOS", config);
          commit("SET_API_AXIOS", config);
          //router.push("/login");
        }
      } catch (error) {
        console.log(error);
      }
    },
    logoutActionHandler({ commit }) {
      var loData = {
        isLoggedIn: false,
        bearerToken: "",
        userData: {}
      };
      commit("LOGOUT_USER", loData);
      router.push("/login").catch((err) => {
        commit("SET_ERROR", err);
      });
    },
    async checkTokenValidty({ getters, commit, state }) {
      //TODO: Validar el tema del Token, ya no usaremos la validacion entre sitios, debe ser un token Shortlived y la validacion probablemente será directo con MCAS (Dapper).

      var model = {
        token: "Bearer " + state.userState.bearerToken,
        userId: getters.userData.nameidentifier
      };

      var logoutUrl = getters.authUrl + "Account/v1.0/CheckTokenValidity";
      try {
        var actionLink = logoutUrl;
        var axiosConfig = getters.axiosConfig;

        const response = await axios.post(actionLink, model, axiosConfig);
        if (response.data.data == false) {
          commit("SET_EXPIRED", true);
          return false;
        }
        return true;
      } catch (error) {
        if (error.response.status == 401) {
          //dispatch("logoutActionHandler");
          commit("SET_EXPIRED", true);
        }
        return false;
      }
    },
    async logoutUser({ dispatch, getters, commit }) {
      var logoutUrl = getters.authUrl + "Account/v1.0/Logoutuser";
      try {
        var actionLink = logoutUrl;
        var axiosConfig = getters.axiosConfig;
        await dispatch("UnloadParameters");
        const response = await axios.post(actionLink, null, axiosConfig);
        return response;
      } catch (error) {
        commit("SET_ERROR", error);
      }
    },
    handleUnauthorizedError({ commit }, error) {
      commit("SET_ERROR", error);
      if (error.response != undefined) {
        if (error.response.status == 401) {
          //dispatch("logoutActionHandler");
          commit("SET_EXPIRED", true);
        } else {
          throw error;
        }
      } else {
        throw error;
      }
    },
    async loadParameters({ commit, getters }) {
      if (!getters.paramLoaded) {
        //await this.dispatch("formatTypes/getFormatTypes", null, { root: true });
        await this.dispatch("audit/getTablesAudit", null, { root: true });
        //await this.dispatch("queues/getQueues", null, { root: true });
        // await this.dispatch("printConditions/getPrintConditions", null, { root: true });
        // await this.dispatch("formats/getFormats", null, { root: true });
        // await this.dispatch("documents/getDocuments", null, { root: true });
        commit("SET_PARAM_LOADED", true);
      }
    },
    async UnloadParameters({ commit }) {
      await this.dispatch("formatTypes/clearFormatTypes", null, { root: true });
      await this.dispatch("audit/clearTablesAudit", null, { root: true });
      // await this.dispatch("queues/clearQueues", null, { root: true });
      // await this.dispatch("printConditions/clearPrintConditions", null, { root: true });
      // await this.dispatch("formats/clearFormats", null, { root: true });
      // await this.dispatch("documents/clearDocuments", null, { root: true });
      commit("SET_PARAM_LOADED", false);
    }
  },
  modules: {
    users: usersModule,
    roles: rolesModule,
    profiles: profilesModule,
    minosParameters: parametersModule,
    userFormAdmin: userFormAdminModule,
    profileUser: profileUserModule,
    persons: personsModule,
    securityParams: securityParamsModule,
    userLimits: userAccessLimits,
    printConditions: printConditionsModule,
    dashboard: dashboardModule,
    formatTypes: formatTypesModule,
    queues: queuesModule,
    formats: formatsModule,
    documents: documentsModule,
    packages: packagesModule,
    dataMaps: dataMapsModule,
    audit: auditModule,
    integrations: integrationsModule,
    valueTypes: ValueTypesVuexModule
  }
});
